import paymentMethod from './payment-method.component';

export default angular
  .module('fizyweb.paycell.noauth.paymentMethod', [])
  .component('fizyPaycellNoAuthPaymentMethod', paymentMethod).name;



// WEBPACK FOOTER //
// src/app/no-auth/components/payment-method/payment-method.module.ts